import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  Typography,
  Alert,
  Collapse,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Loading from '../../../../../components/loading';
import { useSaveEvolution } from '../hooks/useSaveEvolution';

export default function EvolutionModal({ open, onClose, onSaveEvolution, selectedProcedure }) {
  const { save: saveEvolutionRequest } = useSaveEvolution();
  const [isLoading, setLoading] = useState(false);

  const [evolutionDate, setEvolutionDate] = useState(dayjs());
  const [description, setDescription] = useState('');
  const [modalError, setModalError] = useState('');

  useEffect(() => {}, [open]);

  const saveEvolution = () => {
    if (!description.trim()) {
      setModalError('Todos os campos são obrigatórios!');
      return;
    }

    const evolution = {
      data: dayjs(evolutionDate).format('DD/MM/YYYY'),
      descricao: description,
    };

    setLoading(true);
    saveEvolutionRequest(selectedProcedure.id, evolution)
      .then((returnFromApi) => {
        setLoading(false);
        cleanFields();
        onSaveEvolution(returnFromApi);
      })
      .catch((returnFromApi) => {
        setLoading(false);
        setModalError(returnFromApi.response?.data);
        console.error(returnFromApi);
      });
  };

  function cleanFields() {
    setDescription('');
    setEvolutionDate(dayjs());
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <Loading isToHidden={isLoading === false} />

      <DialogTitle>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Adicionar Evolução
        </Typography>
        <Typography variant="body2" color="text.secondary">
          para "{selectedProcedure?.descricao}"
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Collapse in={!!modalError} sx={{ mt: 1, mb: 1 }}>
          <Alert severity="error" onClose={() => setModalError('')}>
            {modalError}
          </Alert>
        </Collapse>

        <Grid>
          <Grid size={1}>
            <DatePicker
              label="Data da Evolução"
              value={evolutionDate}
              onChange={(newValue) => setEvolutionDate(newValue)}
              slotProps={{ textField: { fullWidth: true } }}
            />
          </Grid>
          <Grid size={8}>
            <TextField
              data-cy="evolution-description"
              fullWidth
              label="Descrição"
              multiline
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button data-cy="save-evolution-btn" onClick={saveEvolution} variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
